export default {"src":"/_next/static/media/FLOORLENGTH.bb68b694.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};